import { render } from "./UpdateUser.vue?vue&type=template&id=50463d68&scoped=true"
import script from "./UpdateUser.vue?vue&type=script&lang=js"
export * from "./UpdateUser.vue?vue&type=script&lang=js"

import "./UpdateUser.vue?vue&type=style&index=0&id=50463d68&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50463d68"]])

export default __exports__